export class Usuarios {

    public id:string;
    public nome: string;
    public usuario: string;
    public senha: string;
    public telefone: string;
    public status: string;
    public tipo: string;
    public data_criacao: Date;
    public criado_por: string;
    public gerente: string;
    public agente: string;
    public gerenteNome: string;
    public comissao_simples: number;
    public comissao_multipla: number;
    public comissao_multipla_tres: number;
    public comissao_multipla_quatro: number;
    public comissao_aovivo: number;
    public limite_simples: number;
    public limite_multiplo: number;
    public cancela_apostas: string;
    public aposta_aovivo: string;
    public vendedor_paga: string;
    public cotacao: number;
    public chave_pix: number;
    public carregando: boolean = false;
}
